// i18n 工具类，用于替换 uni.getLocale 和 uni.setLocale
export default {
  getLocale() {
    return localStorage.getItem('locale') || 'zh-Hans'
  },
  setLocale(locale) {
    localStorage.setItem('locale', locale)
  }
}



